import { Tooltip } from '@chakra-ui/react';
import React from 'react';
import styled from 'styled-components';

import AccessibilityIcon from './acessibility-icon';

const AcessibilityContainer = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 146px;
  right: 16px;
  width: 48px;
  height: 48px;
  background-color: #111;
  color: #fff;
  border-radius: 100%;
  cursor: pointer;

  &:hover {
    background-color: #191a1a;
  }

  & svg {
    fill: #fff;
  }
`;

const MobileAcessibilityContainer = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-direction: row;
  color: #fff;
  border-radius: 100%;
  cursor: pointer;

  & svg {
    fill: #fff;
  }
`;

export const AcessibilityMenu = () => {
  const showEqualWebDrawer = (): void => {
    const element = document.getElementById('INDmenu-btn');
    if (element) element.click();
  };

  return (
    <Tooltip label="Acessibilidade" hasArrow placement="bottom-end" bg="black">
      <AcessibilityContainer onClick={showEqualWebDrawer} aria-label="Menu de acessibilidade">
        <span>
          <AccessibilityIcon />
        </span>
      </AcessibilityContainer>
    </Tooltip>
  );
};

export const MobileAcessibilityMenu = () => {
  const showEqualWebDrawer = (): void => {
    const element = document.getElementById('INDmenu-btn');
    if (element) element.click();
  };

  return (
    <Tooltip label="Acessibilidade" hasArrow placement="bottom-end" bg="black">
      <MobileAcessibilityContainer onClick={showEqualWebDrawer} aria-label="Menu de acessibilidade">
        <span>
          <AccessibilityIcon />
        </span>
        Acessibilidade
      </MobileAcessibilityContainer>
    </Tooltip>
  );
};
